// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_5k-6";
export var headerCell = "_5k-2";
export var loadingStateContent = "_5k-8";
export var rowWrapper = "_5k-4";
export var stickyAggregationCell = "_5k-b";
export var stickyAggregationRow = "_5k-7";
export var stickyColumnCell = "_5k-a";
export var stickyColumnHeaderCell = "_5k-9";
export var table = "_5k-1";
export var virtualRowWrapper = "_5k-5";
export var virtualTableContainer = "_5k-0";
export var white = "_5k-3";